const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 330 330",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_20_",
    style: {
      fill: "#0052B4"
    },
    cx: 160,
    cy: 170,
    r: 160
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    style: {
      fill: "#006DF0"
    },
    d: "M160,10c88.365,0,160,71.634,160,160s-71.635,160-160,160"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_22_",
    style: {
      fill: "#FFDA44"
    },
    cx: 160,
    cy: 170,
    r: 120
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_23_",
    style: {
      fill: "#0052B4"
    },
    cx: 160,
    cy: 170,
    r: 80
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    style: {
      fill: "#006DF0"
    },
    d: "M160,90c44.183,0,80,35.817,80,80s-35.817,80-80,80"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_25_",
    style: {
      fill: "#FFDA44"
    },
    cx: 160,
    cy: 170,
    r: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_26_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M241.611,67.175l-8.031,8.031l-28.62,28.62l-29.34,29.34l-22.397,22.398 c-5.857,5.857-5.857,15.355,0,21.213c5.857,5.858,15.355,5.858,21.214,0l22.398-22.397l29.34-29.339l28.619-28.62l8.032-8.031 L241.611,67.175z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_28_",
    style: {
      fill: "#FF5023"
    },
    points: "241.611,67.175 238.076,91.924 280.502,49.497 287.574,0 249.924,37.649  245.146,42.427  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_29_",
    style: {
      fill: "#FF9811"
    },
    points: "238.076,91.924 262.825,88.389 287.573,84.853 292.351,80.075 330,42.427  280.502,49.497  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.c82292099f75cb244aa7af4a22ef9a3f.svg";
export { ForwardRef as ReactComponent };